import React from 'react';
import TopBar from '../../../Components/TopBar';
import BusinessSwitcher from '../BusinessSwitcher';
import Notifications from '../Notifications';
import Page from '../../../Components/Containers/Page';
import { useSession } from '../../../Components/Session';
import { Sections } from '../../../Components/Containers/Section';
import UpdatePrompt from '../../../Components/UpdatePrompt';
import MobileNotifications from '../Widgets/MobileNotifications';
import Onboarding from '../Widgets/Onboarding';
import WorkWidget from '../../Work/Widget';

const HomeRedesign = () => {
    const {showDarkMode} = useSession();

    return (
        <>
            <TopBar
                left={<BusinessSwitcher />}
                title={
                    <img src={showDarkMode ? "/logo-name-horizontal-36-dark.png" : "/logo-name-horizontal-36.png"}
                        className="h-[36px] w-[175px] mt-1 mx-auto"
                        alt="getSoapy"
                        width="175"
                        height="36"
                        onClick={() => window.location.reload(true)}
                    />
                }
                right={<Notifications />}
            />
            <Page>
                <Sections>
                    <UpdatePrompt />
                    <MobileNotifications />
                    <Onboarding />
                    <WorkWidget />
                </Sections>
            </Page>
        </>
    );
};

export default HomeRedesign;
